import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "@shared/redux/store"
import { fetchNominations } from "../redux/nominations.slice"

export default function useNominations(id: number | string) {
    const dispatch = useDispatch()
    const nominations = useSelector<RootState, Jury.Resources.Nomination[]>(state => state.nominations.nominations)

    useEffect(() => {
        dispatch(fetchNominations({ id }))
    }, [])

    return nominations
}